import { render } from "./stackholder-import-modal.vue?vue&type=template&id=84fda628"
import script from "./stackholder-import-modal.vue?vue&type=script&lang=js"
export * from "./stackholder-import-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__